// This file is auto-generated by dibs-icons script
import { type FC } from 'react';
import Listings20 from './Listings20.tsx';
import Listings24 from './Listings24.tsx';

type ListingsProps = {
    variation: '20' | '24';
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const svgVariations = {
    Listings20,
    Listings24,
};

const Listings: FC<ListingsProps> = ({ variation, ...props }) => {
    const variationKey = `Listings${variation}` as keyof typeof svgVariations;
    const Icon = svgVariations[variationKey];

    if (!Icon) {
        // eslint-disable-next-line no-console
        console.error(`"Listings" icon variation ${variationKey} does not exist`);
        return null;
    }

    return <Icon {...props} />;
};

export default Listings;
